import type { ReactNode } from 'react';

import { CardActionContext } from './lib/context';
import type { RuleAction } from './types';

/**
 * Компонент-провайдер для правил действий карточки
 *
 * Оборачивает часть дерева компонентов чтобы сделать правила действий карточки доступными
 * для всех дочерних компонентов, использующих хук useCardAction.
 *
 * @param {Object} props - Пропсы компонента
 * @param {ReactNode} props.children - Дочерние компоненты, которым нужен доступ к правилам действий карточки
 * @param {RuleAction[]} props.rules - Массив определений правил, которые определяют
 *   условное поведение для взаимодействий с карточками. Правила проверяются по порядку до первого совпадения.
 *
 * @example
 * // Предоставление правил для премиум офферов и мобильных устройств
 * <CardActionProvider
 *   rules={[
 *     {
 *       condition: (options) => options.offer.type === 'premium',
 *       action: (event) => showPremiumOffer(event)
 *     },
 *     {
 *       condition: (options) => options.isMobile,
 *       action: (event) => handleMobileTap(event)
 *     }
 *   ]}
 * >
 *   <App />
 * </CardActionProvider>
 */
export function CardActionProvider({ children, rules }: { children: ReactNode; rules: RuleAction[] }) {
  return <CardActionContext.Provider value={rules}>{children}</CardActionContext.Provider>;
}
